import React, { FC } from 'react'
import { Trans } from '../Trans'
import { useFlag } from '@afterpaytouch/feature'
import { AnonymousUserErrorStatus, AnonymousUserErrorVisibility, Features, GenericApiResponseHeaders } from '../../model'
import { useAnonymousUserError } from '../../state'
import { useAmplitude } from 'react-amplitude-hooks'
import { Text } from '@afterpaytouch/core'
import styles from './style.module.css'

interface ErrorIdProps {
  value: string
}

const ErrorId: FC<ErrorIdProps> = ({ value }) => {
  return <span>{value}</span>
}

const extractCorrelationId = (responseHeaders?: GenericApiResponseHeaders): string | undefined => {
  return responseHeaders?.http_correlation_id
}

export const AnonymousUserErrorId: FC = () => {
  const { responseHeaders, errorIdVisibility, status } = useAnonymousUserError()

  const httpCorrelationId = extractCorrelationId(responseHeaders) ?? ''

  const shouldShowErrorId =
    useFlag(Features.ENABLE_CHECKOUT_ERROR_SESSION_IDENTIFIER) &&
    errorIdVisibility === AnonymousUserErrorVisibility.VISIBLE &&
    status === AnonymousUserErrorStatus.DIRTY

  const { amplitudeInstance } = useAmplitude()

  if (!shouldShowErrorId) {
    return null
  }

  const amplitudeSessionId = amplitudeInstance?.getSessionId()?.toString() ?? ''

  const generateErrorIdValue = (): string => {
    const correlationIdString = httpCorrelationId.length > 0 ? `:${httpCorrelationId}` : ''
    return `${amplitudeSessionId}${correlationIdString}`
  }

  return (
    <div className={styles.errorIdWrapper}>
      <Text color={'Fire'} size={'XS'}>
        <Trans i18nKey={'login:error:unknownErrorId'} components={{ errorId: <ErrorId value={generateErrorIdValue()} /> }} />
      </Text>
    </div>
  )
}
